import { Button } from "@astryxdesign/core/Button";
import { HTTPError } from "ky";
import * as stylex from "@stylexjs/stylex";
import { errorMessage, isUnauthorized, isFreshAuthenticationRequired } from "../lib/api";
import { signInURL, freshSignInURL } from "../lib/navigation";
import { styles } from "../lib/styles";
export function RequestFailure({
  error,
  retry,
  pending = false
}: {
  error: unknown;
  retry?: () => void;
  pending?: boolean;
}) {
  if (!error) return null;
  const forbidden = error instanceof HTTPError && error.response.status === 403;
  const message = isUnauthorized(error) ? "Your session has expired. Sign in again to continue; your current page will be restored." : forbidden ? "Your account does not have permission to view this information. Contact your administrator if you need access." : errorMessage(error);
  return <div role="alert" {...stylex.props(styles.error)}>
      <p>{message}</p>
      <div {...stylex.props(styles.actions)}>
        {isUnauthorized(error) && <a href={signInURL()} {...stylex.props(styles.primaryLink)}>
            Sign in again
          </a>}
        <ReauthenticationAction error={error} />
        {retry && <Button label="Try again" onClick={retry} isLoading={pending} />}
      </div>
    </div>;
}
export function ReauthenticationAction({
  error
}: {
  error: unknown;
}) {
  if (!isFreshAuthenticationRequired(error)) return null;
  return <span>
      Fresh sign-in is required.{" "}
      <a href={freshSignInURL()} target="_blank" rel="noopener">
        Reauthenticate in new tab
      </a>
      , then retry here. Your current page and entries stay open.
    </span>;
}